var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8926",
    "data-name": "Group 8926",
    transform: "translate(-56.195 -706.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_67_1",
    "data-name": "Component 67 \\u2013 1",
    transform: "translate(56.195 706.588)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4338",
    "data-name": "Rectangle 4338",
    width: 73,
    height: 73,
    rx: 8,
    fill: "#113252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(91.048 737.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M31.58,285.221c-1.207-9.032.023-17.5,5.379-25.134a9.476,9.476,0,0,1,1.774-2s13.215.046,18.707.046C58.322,270.508,50.159,283.729,31.58,285.221Z",
    transform: "translate(-31.154 -250.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M49.547,255.322q.282,2.089.379,4.134c-7,0-7.933.054-14.356.054A32,32,0,0,1,49.547,255.322Z",
    transform: "translate(-22.999 -255.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M23.093,265.044l5.854-11.074,15.391-5.379,14.34,4.309,8.047,12.144",
    transform: "translate(-46.048 -267.758)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M57.53,261.855,52.758,253.6l-11.574-3.346-11.238,3.109-5.111,8.494v23.414H40.369l1.079-4.88A20.4,20.4,0,0,1,53.39,266.021l4.14-1.757Z",
    transform: "translate(-42.834 -264.689)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFarm);
export default __webpack_public_path__ + "static/media/newFarm.4edadb07f5aec03a3f93f032f8f0da77.svg";
export { ForwardRef as ReactComponent };